import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateEdge } from '@lingaai/supabase-client';
import type { UpdateEdgeInput } from '@lingaai/types';

/**
 * Hook to update an edge's properties
 */
export function useUpdateEdge() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ edgeId, updates }: { edgeId: string; updates: UpdateEdgeInput }) => updateEdge(edgeId, updates),
    onSuccess: (edge) => {
      // Invalidate relationship queries for both connected nodes
      queryClient.invalidateQueries({
        queryKey: ['node-with-relationships', edge.src],
        refetchType: 'active',
      });
      queryClient.invalidateQueries({
        queryKey: ['node-with-relationships', edge.dst],
        refetchType: 'active',
      });
      queryClient.invalidateQueries({
        queryKey: ['edges'],
        refetchType: 'active',
      });
    },
    onError: (error: unknown) => {
      console.error('Failed to update edge:', error);
      throw error;
    },
  });
}
